/***
 * 创建人：李珊
 * 时间：2020-12-12
 * 描述：素材库——素材管理——抓取源管理：新增及编辑操作
 * 更新说明:
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { KmsEnum } from '../../../serves/kms-enum';
@Component({
  selector: 'app-grab-source-add',
  templateUrl: './grab-source-add.component.html',
  styleUrls: ['./grab-source-add.component.css']
})
export class GrabSourceAddComponent implements OnInit {
  
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  //数据绑定对象
  grabSourceModel: any = { }; 
  //标头提示信息
  headerLoGo: string; 
  // 抓取类型选项
  crawlTypeOptions = KmsEnum.crawlTypeOptions;
  //提交按钮是否禁用
  clickEnable = true; 
  constructor(
    private box: SwMassageBoxService,  //消息提示框
    private service: KmsService,   //请求服务
  ) { 

  }

  ngOnInit() {
    this.clickLoca(this.param["upOrAdd"],this.param["selectedData"]);
  }
  //抓取源点击新增 或者 修改
  clickLoca(upOrAdd: string, selectedData: any) {
    //修改操作
    if (upOrAdd == "Edit") {
      //修改提示头
      this.headerLoGo = "编辑抓取源信息"
      // 查询抓取源信息
      this.service.queryCrawlWebsiteById(selectedData.websiteId).subscribe(
        data => {
          if (data["code"] == '200') {
            this.grabSourceModel = data["data"];
          }
        }
      )
    } else {
      //新增抓取源数据 默认绑定抓取源基础数据
      this.headerLoGo = "新增抓取源信息";
      this.grabSourceModel.websiteStatus = 0;
    }
  }

  //提交 保存 或者修改操作
  onSubmit({ value, valid }, event: Event) {
    if (valid) {
      if(this.param['upOrAdd'] == 'Edit'){
        value['websiteId'] = this.grabSourceModel.websiteId;
      }
      this.clickEnable = false;
      this.service.saveOrUpdateCrawlWebsite(value).subscribe(
        data => {
          this.clickEnable = true;
          if (data["code"] == '200') {
            this.grabSourceModel = data["data"];
            //抛出事件 提示 关闭模态框
            this.modal.toggle();
            this.callback.emit(true);
            this.box.success('保存成功');
          }else{
            this.box.waring(data.msg);
          }
        }
      )
    }else {
      this.box.waringError('请输入完整且正确的信息')
    }
  }
}
